import { render, staticRenderFns } from "./BlockContentImage.vue?vue&type=template&id=201c7536&"
import script from "./BlockContentImage.vue?vue&type=script&lang=js&"
export * from "./BlockContentImage.vue?vue&type=script&lang=js&"
import style0 from "./BlockContentImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports